import { LocalStorage } from 'src/utils/LocalStorage'
import { defaultUserInfo } from './../interfaces/user.d'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { get } from 'lodash'

import automaticPlanRequest from 'src/api/requests/automaticPlan'
import { FormValues as FormValuesIdentification } from 'src/containers/AutomaticPlan/Identification/Form/useIdentification'
import { FormValues as FormValuesUploadImage } from 'src/containers/AutomaticPlan/UploadImage/Form/useUploadImage'
import { PATH as PATH_COMPLETE_IDENTIFICATION } from 'src/pages/automaticPlan/CompleteIdentification'
import { PATH as PRECAUTION_PATH } from 'src/pages/automaticPlan/Precaution'
import uiActions from 'src/store/ui/notification'
import history from 'src/libs/history'
import appActions from 'src/store/ui/app'
import uploadProgressActions from 'src/store/ui/uploadProgress'
import { UserInterface } from 'src/interfaces/user'
import userRequest from 'src/api/requests/user'
export interface payloadUpdateIdentityCard {
  data: FormValuesIdentification
}

export interface payloadUploadHeadImage {
  data: FormValuesUploadImage
}

export const updateIdentityCard = createAsyncThunk<
  any,
  payloadUpdateIdentityCard
>('update-identity-card', async ({ data }, { dispatch }) => {
  try {
    const userTreatmentId = Number(LocalStorage.getUserTreatmentId())

    const frontContentType = data.front_side_card.type as
      | 'image/jpeg'
      | 'image/jpg'
      | 'image/png'
    const backContentType = data.back_side_card?.type as
      | 'image/jpeg'
      | 'image/jpg'
      | 'image/png'
      | undefined

    const presignedRes =
      await automaticPlanRequest.getIdentityCardPresignedUrls({
        front_side_content_type: frontContentType,
        ...(backContentType ? { back_side_content_type: backContentType } : {}),
      })
    const { front_side, back_side } = presignedRes.data

    const hasBackSide = Boolean(
      back_side && data.back_side_card && backContentType,
    )
    const totalUploads = hasBackSide ? 2 : 1
    dispatch(uploadProgressActions.startUpload({ total: totalUploads }))

    // S3 PUT は Bearer token を送ってはいけないため fetch を直接使用する
    const uploads = [
      fetch(front_side.upload_url, {
        method: 'PUT',
        headers: { 'Content-Type': frontContentType },
        body: data.front_side_card,
      }).then((res) => {
        dispatch(uploadProgressActions.incrementUploaded())
        return res
      }),
    ]

    if (back_side && data.back_side_card && backContentType) {
      uploads.push(
        fetch(back_side.upload_url, {
          method: 'PUT',
          headers: { 'Content-Type': backContentType },
          body: data.back_side_card,
        }).then((res) => {
          dispatch(uploadProgressActions.incrementUploaded())
          return res
        }),
      )
    }

    const uploadResponses = await Promise.all(uploads)
    uploadResponses.forEach((res) => {
      if (!res.ok) {
        throw new Error(`S3 upload failed: ${res.status}`)
      }
    })

    await automaticPlanRequest.confirmIdentityCard({
      front_side_card: front_side.s3_key,
      ...(back_side ? { back_side_card: back_side.s3_key } : {}),
      user_treatment_id: userTreatmentId,
    })

    const res = await userRequest.userInfo({
      with: 'reservations,card,stateTransitions,cycleOrderPaid,latestOrderCanPay',
    })
    dispatch(appActions.updateAuthInfo(res.data))
    dispatch(uploadProgressActions.completeUpload())
    setTimeout(() => {
      dispatch(uploadProgressActions.hideUploadProgress())
      history.push(PATH_COMPLETE_IDENTIFICATION)
    }, 1200)
  } catch (e) {
    dispatch(uploadProgressActions.hideUploadProgress())
    dispatch(
      uiActions.onNotification({
        type: 'error',
        message: '問題が発生したため、再度アップロードしてください。',
      }),
    )
  }
})
export const uploadHeadImage = createAsyncThunk<any, payloadUploadHeadImage>(
  'upload_head_image',
  async ({ data }, { dispatch, getState }) => {
    try {
      const res = await automaticPlanRequest.uploadHeadImage(data)
      const headImage = res && res.data?.head_image
      if (headImage) {
        const state = getState()

        const user: UserInterface = get(
          state,
          'ui.app.authInfo',
          defaultUserInfo,
        )
        const newUser: UserInterface = { ...user, head_image: headImage }
        if (newUser) {
          dispatch(appActions.updateAuthInfo(newUser))
        }
      }

      history.push(PRECAUTION_PATH)
    } catch (e) {
      dispatch(
        uiActions.onNotification({
          type: 'error',
          message: '問題が発生したため、再度アップロードしてください。',
        }),
      )
    }
  },
)
